import request from './request';
import deserialize from './deserialize';

export type LoyaltyProgram = {
  id: string;
  qrMainTitle: string;
  qrRegenCodeInterval: number;
  qrSubTitle: string;
  stampRateLimit: number;
  menuUnlockPin: string;
  stampCampaign: { id: string };
};

export function get(id: string) {
  return request<LoyaltyProgram>({
    url: `/companion/v1/companies/${id}/loyalty_programs`,
    method: 'GET',
    transformResponse: deserialize,
  });
}
